module.exports = __webpack_public_path__ + "static/media/gw.612ef7e4.svg";